import { useEffect, useState } from 'react';
import { FontIcon } from '@fluentui/react/lib/Icon';
import '../Styles/MyTimeAdd.scss';
import { UserRegistrationPeriod } from '../api/generated/data-contracts';
interface MyTimeAddProps {
    pinned: boolean;
    isMyTime: boolean;
    pinMyTime: Function;
    Time: UserRegistrationPeriod;
}
function MyTimeAdd(props: MyTimeAddProps) {
    const [pinned, setPinned] = useState<boolean>(false);
    const [groupiconrotation, setGroupiconrotation] = useState<string>('rotate(-90deg)');
    const [opacity, setOpacity] = useState<number>(0.4);

    const clicked = e => {
        if (pinned === false) {
            setPinned(true);
            //props.Time.pinned = true;
            props.pinMyTime(props.Time, true);
        } else {
            //if (!props.isMyTime)
            {
                setPinned(false);
            }
            props.pinMyTime(props.Time, false);
        }
    };
    useEffect(() => {
        setPinned(props.pinned);
    }, [props.pinned]);

    useEffect(() => {
        if (!pinned) {
            setGroupiconrotation('rotate(-90deg)');
            setOpacity(0.4);
        } else {
            setGroupiconrotation('rotate(-45deg)');
            setOpacity(1);
        }
    }, [pinned]);
    return (
        <div className={`pinContainer${pinned ? ' activePin' : ''}`} onClick={clicked}>
            <FontIcon
                iconName="Pin"
                className="pinIcon"
                style={{
                    transform: groupiconrotation,
                    opacity: opacity,
                }}
            />
        </div>
    );
}

export default MyTimeAdd;
